// removed by extract-text-webpack-plugin
module.exports = {"tagsCover":"tagsCover__3CJ3n","tagsCoverContainer":"tagsCoverContainer__1tXq6","tagsCoverHeader":"tagsCoverHeader__1cMcy","tagsCoverFooter":"tagsCoverFooter__1_9gR","tagsLength":"tagsLength__2-e0h"};


//////////////////
// WEBPACK FOOTER
// ./components/ott/style.less
// module id = 7iVu
// module chunks = 75